import { cx } from '@linaria/core';
import { titleCls, spanCls, captionCls } from './caption.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Caption(props) {
  if (!props.caption) {
    return null;
  }
  return /*#__PURE__*/jsxs("div", {
    className: cx(captionCls, props.scrambled && "scrambled", props.position),
    children: [props.caption.title?.showInContext && /*#__PURE__*/jsx("span", {
      className: cx(titleCls, spanCls),
      dangerouslySetInnerHTML: {
        __html: props.caption.title.value
      }
    }), props.caption.description?.showInContext && /*#__PURE__*/jsx("span", {
      className: spanCls,
      dangerouslySetInnerHTML: {
        __html: props.caption.description.value
      }
    }), props.caption.caption?.showInContext && /*#__PURE__*/jsx("span", {
      className: spanCls,
      dangerouslySetInnerHTML: {
        __html: props.caption.caption.value
      }
    }), props.caption.authorOrArtist?.showInContext && /*#__PURE__*/jsx("span", {
      className: spanCls,
      dangerouslySetInnerHTML: {
        __html: props.caption.authorOrArtist.value
      }
    }), props.caption.country?.showInContext && /*#__PURE__*/jsx("span", {
      className: spanCls,
      dangerouslySetInnerHTML: {
        __html: props.caption.country.value
      }
    }), props.caption.duration?.showInContext && /*#__PURE__*/jsx("span", {
      className: spanCls,
      dangerouslySetInnerHTML: {
        __html: props.caption.duration.value
      }
    }), props.caption.year?.showInContext && /*#__PURE__*/jsx("span", {
      className: spanCls,
      dangerouslySetInnerHTML: {
        __html: props.caption.year.value
      }
    }), props.caption.copyright?.showInContext && props.caption.copyright?.value && /*#__PURE__*/jsx("span", {
      className: spanCls,
      dangerouslySetInnerHTML: {
        __html: "©&nbsp;" + props.caption.copyright.value
      }
    })]
  });
}

export { Caption };
//# sourceMappingURL=caption.js.map
